export enum OscPlatform {
  Desktop = 'desktop',
  Web = 'web'
}
